import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { DeviceCoverageComponent } from './components/device-coverage/device-coverage.component';
import { ProductDescriptionComponent } from './components/product-description/product-description.component';
import { ProductInformationComponent } from './components/product-information/product-information.component';
import { ProductNotFoundComponent } from './components/product-not-found/product-not-found.component';
import { ProductOverviewComponent } from './components/product-overview/product-overview.component';
import { RequestComponent } from './components/request/request.component';
import { StatusComponent } from './components/status/status.component';

const routes: Routes = [
  {path: '', redirectTo:  'home', pathMatch:  'full'},
  {path: "home", component: ProductInformationComponent},
  {path: "description/:serialNumber", component: ProductDescriptionComponent},
  {path: "request/:serialNumber", component: RequestComponent},
  //{path: "request", component: RequestComponent},
  {path: "overview/:serialNumber", component: ProductOverviewComponent},
  {path: "confirm/:requestId", component: ConfirmComponent},
  {path: "status/:requestId", component: StatusComponent},
  {path: "notfound/:serialNumber", component: ProductNotFoundComponent},
  {path: "coverage", component: DeviceCoverageComponent}
  //{ path: "**", component: ErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
